/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_Point_3Inputs */

const en_services_svc_full_point_3 = /** @type {(inputs: Services_Svc_Full_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-hosted or cloud infrastructure, monitored, with tested backups`)
};

const lv_services_svc_full_point_3 = /** @type {(inputs: Services_Svc_Full_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pašu vai mākoņa infrastruktūra ar uzraudzību un pārbaudītām rezerves kopijām`)
};

/**
* | output |
* | --- |
* | "Self-hosted or cloud infrastructure, monitored, with tested backups" |
*
* @param {Services_Svc_Full_Point_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_point_3 = /** @type {((inputs?: Services_Svc_Full_Point_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_Point_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_point_3(inputs)
	return en_services_svc_full_point_3(inputs)
});